interface WorldGeographyProps {
  geography: {
    description: string
    worldSize?: string
    climate: string
    terrain: (string | { name: string; description: string })[]
    naturalResources: (string | { name: string; description: string })[]
    notableLocations: (string | { name: string; description: string })[]
    dangerousZones?: { name: string; description: string }[]
  }
}

export function WorldGeography({ geography }: WorldGeographyProps) {
  const renderItem = (item: string | { name: string; description: string }) => {
    if (typeof item === 'string') {
      return item
    }
    return (
      <div>
        <div className="font-medium">{item.name}</div>
        <div className="text-xs text-muted-foreground mt-1">{item.description}</div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <div>
        <h3 className="font-semibold mb-2">概要</h3>
        <p className="text-sm text-muted-foreground">{geography.description}</p>
      </div>
      
      {geography.worldSize && (
        <div>
          <h3 className="font-semibold mb-2">世界の規模</h3>
          <p className="text-sm text-muted-foreground">{geography.worldSize}</p>
        </div>
      )}
      
      <div>
        <h4 className="text-sm font-semibold mb-2">気候</h4>
        <p className="text-sm text-muted-foreground">{geography.climate}</p>
      </div>
      
      <div>
        <h4 className="text-sm font-semibold mb-2">地形</h4>
        <div className="space-y-2">
          {geography.terrain.map((terrain, index) => {
            const isObject = typeof terrain === 'object' && terrain !== null
            return (
              <div key={index} className="p-3 bg-green-50 rounded-lg">
                {isObject ? (
                  <>
                    <div className="font-medium text-sm text-green-700">
                      {terrain.name}
                    </div>
                    <div className="text-xs text-muted-foreground mt-1">
                      {terrain.description}
                    </div>
                  </>
                ) : (
                  <div className="text-sm text-green-700">{String(terrain)}</div>
                )}
              </div>
            )
          })}
        </div>
      </div>
      
      {geography.naturalResources && geography.naturalResources.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2">天然資源</h4>
          <div className="space-y-2">
            {geography.naturalResources.map((resource, index) => {
              const isObject = typeof resource === 'object' && resource !== null
              return (
                <div key={index} className="p-3 bg-amber-50 rounded">
                  {isObject ? (
                    <>
                      <div className="font-medium text-sm text-amber-700">
                        {resource.name}
                      </div>
                      <div className="text-xs text-muted-foreground mt-1">
                        {resource.description}
                      </div>
                    </>
                  ) : (
                    <div className="text-sm text-amber-700">{String(resource)}</div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}
      
      {geography.notableLocations && geography.notableLocations.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2">重要な場所</h4>
          <div className="space-y-2">
            {geography.notableLocations.map((location, index) => {
              const isObject = typeof location === 'object' && location !== null
              return (
                <div key={index} className="p-3 bg-blue-50 rounded-lg">
                  {isObject ? (
                    <>
                      <div className="font-medium text-sm text-blue-700">
                        {location.name}
                      </div>
                      <div className="text-xs text-muted-foreground mt-1">
                        {location.description}
                      </div>
                    </>
                  ) : (
                    <div className="text-sm text-blue-700">{String(location)}</div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}
      
      {geography.dangerousZones && geography.dangerousZones.length > 0 && (
        <div>
          <h4 className="text-sm font-semibold mb-2">危険地帯</h4>
          <div className="space-y-2">
            {geography.dangerousZones.map((zone, index) => (
              <div key={index} className="p-3 bg-red-50 rounded-lg">
                <div className="font-medium text-sm text-red-700">
                  {zone.name}
                </div>
                <div className="text-xs text-muted-foreground mt-1">
                  {zone.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}